import { Component } from '@angular/core';
import { IonicPage, ModalController, NavController, NavParams } from 'ionic-angular';
import { CrudProvider } from '../../providers/crud/crud';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CabsandFleetinfoAddPage } from '../cabsand-fleetinfo-add/cabsand-fleetinfo-add';
import { SearchPage } from '../search/search';

@IonicPage()
@Component({
  selector: 'page-cabsand-fleetinfo',
  templateUrl: 'cabsand-fleetinfo.html',
})
export class CabsandFleetinfoPage {
  fleetList: any = [];
  appColor:String;
  actionAllowed:boolean = false;
  allFleetList : any = [];
  selectedFleet:any = null;
  previewAllowed: boolean= false;
  constructor(public navCtrl: NavController, public navParams: NavParams, private api: CrudProvider, public utiltiy: UtiltiyProvider,private modalController: ModalController) {
  }

  ionViewDidLoad() {
    this.getPermission();
    this.getMetaData();
  }

  async getMetaData(){
    this.allFleetList = await this.getAllData("get_all_fleeet_no");
    this.getData();
  }

  getData(){
    if(!this.selectedFleet || this.selectedFleet == "All"){
      console.log("1");
      this.getfleetList();
    }else{
      console.log("1");

      this.getAllfleetList();
    }
  }

  async deleteRecord(id) {
    let status = await this.utiltiy.showDialog();
    if (status) {
      this.deletefleetList(id);
    }
  }

  dateInPast = (firstDate, secondDate) =>
  firstDate.setHours(0, 0, 0, 0) <= secondDate.setHours(0, 0, 0, 0);



  getfleetList() {
    this.fleetList = [];
    this.utiltiy.startLoading();
    this.api.get("/tansix_prestart/Fleet_Information/Fleet_Information", false)
      .then((result: any) => {
        result.result.forEach(element => {
          let code = 3;
          if(element.Rego_Due_Date.length != 0){
            var dueDate = new Date(element.Rego_Due_Date) as any;
            var today = new Date() as any;
            let status =  this.dateInPast(dueDate, today);
            const diffTime = Math.abs(dueDate - today);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if(status){
               code = 3;
            }else{
              if(diffDays <= 30){
                 code = 2;
              } else{
                 code = 1;
              }
            }
          }

          element.dueCode = code;
        });
        console.log("result", result)

        this.fleetList = result.result;
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }


  getAllfleetList() {
    this.fleetList = [];
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "search_by_fleet_no");
    formData.append("search_by_fleet_no", this.selectedFleet);
    this.api.post("/tansix_prestart/Fleet_Information/Fleet_Information", false,formData)
      .then((result: any) => {
        result.result.forEach(element => {
          let code = 3;
          if(element.Rego_Due_Date.length != 0){
            var dueDate = new Date(element.Rego_Due_Date) as any;
            var today = new Date() as any;
            let status =  this.dateInPast(dueDate, today);
            const diffTime = Math.abs(dueDate - today);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if(status){
               code = 3;
            }else{
              if(diffDays <= 30){
                 code = 2;
              } else{
                 code = 1;
              }
            }
          }

          element.dueCode = code;
        });
        console.log("result", result)

        this.fleetList = result.result;
        this.utiltiy.stopLoading();
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  async getAllData(method){
    let formData: FormData = new FormData();
    formData.append("method_name", method);
   
    return this.api.post("/tansix_prestart/Fleet_Information/Fleet_Information", false, formData)
      .then((result: any) => {
        console.log("result", result)
        if (result.status) {
          let data = [{"fleet_no":"All"}];
          return [...data,...result.result];
        }else{
         return [];
        }
      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
        return [];
      })
  }

  async createData(list, key, value) {
    list.forEach(element => {
      element.key = element[key];
      element.value = element[value];
    });

    return list;
  }

  async openModal(list, title, key, value) {
    list = await this.createData(list, key, value);
    const profileModal = this.modalController.create(SearchPage, { data: { list: list, header: title } }, { cssClass: 'managers', enableBackdropDismiss: true });
    profileModal.onDidDismiss(data => {
      console.log(value,"value",data);
      if (data) {
        this.selectedFleet = data.fleet_no;
        this.getData();
      }
    });
    profileModal.present();
  }

  deletefleetList(id) {
    this.utiltiy.startLoading();
    let formData: FormData = new FormData();
    formData.append("method_name", "delete_fleet_information");
    formData.append("id", id);
    this.api.post(`/tansix_prestart/Fleet_Information/Fleet_Information`, false,formData)
      .then((result: any) => {
        console.log("result", result)
        this.utiltiy.stopLoading();
        if (result.status) {
          this.utiltiy.toaster(result.message);
          this.getfleetList();
        }

      }, err => {
        this.utiltiy.stopLoading();
        this.utiltiy.toaster(err.error.message);
      })
  }

  addFleet(){
    this.navCtrl.push(CabsandFleetinfoAddPage, { param: null,disable:false  });
  }
  updateFleet(prestart){
    this.navCtrl.push(CabsandFleetinfoAddPage, { param: prestart,disable:false  });
  }
  previewFleet(prestart){
    this.navCtrl.push(CabsandFleetinfoAddPage, { param: prestart,disable:true  });
  }
  async getPermission(){
   this.actionAllowed =  await this.utiltiy.getPagePermission("cabsand-fleet-information-rw");
   this.previewAllowed =  await this.utiltiy.getPagePermission("cabsand-fleet-information-ro");

  }

}



// WEBPACK FOOTER //
// ./src/pages/cabsand-fleetinfo/cabsand-fleetinfo.ts